import { editAndRelayoutText } from '../../state/actions/edit-and-relayout-text';
import { FontStyle, TextItem } from './text-item-type';

export type TextItemHoverPreview =
  | {
      itemId: string;
      type: 'font-family';
      fontFamily: string;
    }
  | {
      itemId: string;
      type: 'font-style';
      fontStyle: FontStyle;
    };

export const overrideTextItemWithHoverPreview = ({
  textItem,
  hoverPreview,
}: {
  textItem: TextItem;
  hoverPreview: TextItemHoverPreview | null;
}): TextItem => {
  if (hoverPreview === null) {
    return textItem;
  }
  if (hoverPreview.itemId !== textItem.id) {
    return textItem;
  }

  if (hoverPreview.type === 'font-family') {
    return editAndRelayoutText(textItem, () => {
      console.log('[HoverPreview font-family] BEFORE:', {
        fontFamily: textItem.fontFamily,
        segments: JSON.stringify(textItem.segments),
      });

      if (
        textItem.fontFamily === hoverPreview.fontFamily &&
        !textItem.segments?.some((s) => s.fontFamily)
      ) {
        console.log('[HoverPreview font-family] SKIP - no change needed');
        return textItem;
      }

      // Preview 시 segments의 fontFamily도 제거하여 전체 적용되도록 함
      let newSegments = textItem.segments?.map((seg) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { fontFamily: _, ...rest } = seg;
        return rest;
      });
      const hasStyledSegments = newSegments?.some(
        (s) =>
          s.color ||
          s.fontWeight ||
          s.fontVariant ||
          s.fontSize ||
          s.opacity !== undefined,
      );
      if (!hasStyledSegments) {
        newSegments = undefined;
      }

      const result = {
        ...textItem,
        fontFamily: hoverPreview.fontFamily,
        segments: newSegments,
      };

      console.log('[HoverPreview font-family] AFTER:', {
        fontFamily: result.fontFamily,
        segments: JSON.stringify(result.segments),
      });

      return result;
    });
  }

  if (hoverPreview.type === 'font-style') {
    return editAndRelayoutText(textItem, () => {
      const hasSegmentFontStyle = textItem.segments?.some(
        (s) => s.fontWeight || s.fontVariant,
      );
      if (
        textItem.fontStyle.variant === hoverPreview.fontStyle.variant &&
        textItem.fontStyle.weight === hoverPreview.fontStyle.weight &&
        !hasSegmentFontStyle
      ) {
        return textItem;
      }

      // Preview 시 segments의 fontWeight, fontVariant도 제거하여 전체 적용되도록 함
      let newSegments = textItem.segments?.map((seg) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { fontWeight: _w, fontVariant: _v, ...rest } = seg;
        return rest;
      });
      const hasStyledSegments = newSegments?.some(
        (s) => s.color || s.fontFamily || s.fontSize || s.opacity !== undefined,
      );
      if (!hasStyledSegments) {
        newSegments = undefined;
      }

      return {
        ...textItem,
        fontStyle: hoverPreview.fontStyle,
        segments: newSegments,
      };
    });
  }

  throw new Error(
    `Invalid hover preview type: ${JSON.stringify(hoverPreview satisfies never)}`,
  );
};
